/**
 * Serializador de writes por clave.
 *
 * Garantiza el invariante que la PK por `client_uuid` de la capa offline asume: dos writes sobre el
 * MISMO `client_uuid` commitean en ORDEN DE LLEGADA. Sin esto, dos `addAddon` concurrentes sobre la
 * misma fila (coalesce por client_uuid) podían commitear fuera de orden — si un write PARCIAL (de un
 * debounce intermedio) commiteaba después del write FINAL, quedaba persistida "la mitad del comentario"
 * al salir rápido del ítem (TKT-2280/2319, hallazgo QA).
 *
 * La serialización vive acá (fachada) y no en el componente: así protege a TODOS los callers de un mismo
 * client_uuid de una vez (el placeholder vacío de addComment/addDocument y el texto/valor que llega
 * después por updateAddon), no solo a una instancia de OccurrenceItemAddonsSection.
 *
 * Writes con claves DISTINTAS corren en paralelo — solo se serializa por clave. Un write que rechaza no
 * rompe la cadena de su clave: el siguiente igual arranca (el `.catch` interno solo mantiene el orden;
 * el reporte del error queda a cargo del caller).
 */
export function createKeyedSerializer () {
  const chains = new Map()

  return function run (key, task) {
    const prev = chains.get(key) || Promise.resolve()
    const next = prev.catch(() => {}).then(() => task())
    chains.set(key, next)

    // Poda: al asentarse, si sigue siendo la cola de su clave, se borra la entrada para que el Map no
    // crezca sin límite en sesiones largas. Un write posterior arranca limpio desde Promise.resolve(),
    // lo que conserva el orden (el anterior ya se asentó).
    next.catch(() => {}).finally(() => {
      if (chains.get(key) === next) chains.delete(key)
    })

    return next
  }
}
